import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'


const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    permissions: [], // 用户权限列表
    totalCount:'',
    allnum:'0',
    currentUserProfile: {},
    isLogin: false,
  },

  mutations: {
    setallnum: (state, token) => {
      state.allnum = token
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },   
    total_Count: (state, {totalCount}) => {
      state.totalCount = totalCount
    },
    updateCurrentUserProfile(state, userProfile) {
      state.currentUserProfile = userProfile
    },
    toggleIsLogin(state, isLogin) {
      state.isLogin = typeof isLogin === 'undefined' ? !state.isLogin : isLogin
    },

  },

  actions: {
    totalCount({ commit }, data){
       commit ('total_Count',{totalCount:data.totalCount})
    },
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          const data = response.data
          const tokenStr = data.tokenHead+data.token
          setToken(tokenStr)
          commit('SET_TOKEN', tokenStr)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const data = response.data
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }
          // 设置用户权限（如果后端返回了permissions字段）

          console.log("data....",data)
          if (data.permissions && data.permissions.length > 0) {
            commit('SET_PERMISSIONS', data.permissions)
          } else {
            commit('SET_PERMISSIONS', [])
          }
          commit('SET_NAME', data.username)
          commit('SET_AVATAR', data.icon)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          // 清空Vuex状态
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          commit('SET_NAME', '')
          commit('SET_AVATAR', '')
          removeToken()
          
          // 清空localStorage缓存（保留urlcode配置）
          const urlcode = localStorage.getItem('urlcode')
          localStorage.clear()
          if (urlcode) {
            localStorage.setItem('urlcode', urlcode)
          }
          
          // 清空sessionStorage缓存
          sessionStorage.clear()
          
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        // 清空Vuex状态
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        commit('SET_PERMISSIONS', [])
        commit('SET_NAME', '')
        commit('SET_AVATAR', '')
        removeToken()
        
        // 清空localStorage缓存（保留urlcode配置）
        const urlcode = localStorage.getItem('urlcode')
        localStorage.clear()
        if (urlcode) {
          localStorage.setItem('urlcode', urlcode)
        }
        
        // 清空sessionStorage缓存
        sessionStorage.clear()
        
        resolve()
      })
    },

  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js